<template>
  <span>We have {{ length() }} icons from <services-list />.</span>
</template>
<script>
import ServicesList from './services-list'

export default {
  name: 'IntroText',
  components: {
    ServicesList
  },
  data () {
    return {
      icons: this.$store.getters.icons
    }
  },
  methods: {
    length () {
      let length = 0
      const icons = this.icons
      Object.keys(icons).forEach(service => {
        length = parseInt(length + icons[service].length, 10)
      })
      return length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/intro-text.vue